import Popin from './popin';

export default videoPopin => {
    // console.log('videoPopin');
    const dataPopin = videoPopin.getAttribute('data-popin');
    const dataYoutube = videoPopin.getAttribute('data-youtube');
    const popin = document.querySelector(`#${dataPopin}`);
    const videoContainer = popin.querySelector('.video-container');
    const loader = popin.querySelector('.loading-please-wait');

    function loading() {
        loader.parentNode.classList.add('loading');
    }

    function noMoreLoading() {
        loader.parentNode.classList.remove('loading');
    }

    function createiFrame() {
        videoContainer.innerHTML = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${dataYoutube}?autoplay=true" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    }

    function removeiFrame() {
        videoContainer.innerHTML = '';
    }

    videoPopin.addEventListener('click', () => {
        Popin({
            id: dataPopin,
            beforeOpen() {
                createiFrame();
                noMoreLoading();
            },
            afterClose() {
                removeiFrame();
                loading();
            },
        });
    });
};
